// extracted by mini-css-extract-plugin
export var container = "styles-module__container___E29T0";
export var showMore = "styles-module__showMore___MxjUp";